import React from "react";
import { Button } from "../components/ui/button";
import { THEME, profile } from "../mock";

const nav = [
  { href: "#about", label: "About" },
  { href: "#skills", label: "Skills" },
  { href: "#services", label: "Services" },
  { href: "#portfolio", label: "Projects" },
  { href: "#experience", label: "Experience" },
  { href: "#education", label: "Education" },
  { href: "#contact", label: "Contact" },
  { href: "/admin", label: "Admin" },
];

export default function Header() {
  const onConsult = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className={`sticky top-0 z-40 border-b ${THEME.primaryBg} border-slate-800/60`}> 
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-sky-600"></div>
          <span className="text-white font-semibold tracking-tight">{profile.name}</span>
        </a>
        <nav className="hidden md:flex items-center gap-6">
          {nav.map((n) => (
            <a key={n.href} href={n.href} className="text-slate-300 hover:text-white text-sm">
              {n.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Button onClick={onConsult} className={`hidden md:inline-flex bg-sky-600 hover:bg-sky-700 text-white`}>Request Consulting</Button>
        </div>
      </div>
    </header>
  );
}